import React from 'react';
import Download from '../assets/images/DownloadBlue.svg';

export default () => {
  return <img src={Download} alt="" />;
};
